import { Button } from '@cian/ui-kit';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

interface IHeartFavouriteButtonProps {
  isFavourite: boolean;
  onClick(): void;
}

export const HeartFavouriteButton: React.FC<IHeartFavouriteButtonProps> = ({ isFavourite, onClick }) => {
  return (
    <Button
      size="M"
      theme="stroke_primary"
      onClick={onClick}
      beforeIcon={
        isFavourite ? (
          <IconToggleHeartOn16 color="icon-negative-default" />
        ) : (
          <IconToggleHeartOff16 color="icon-main-default" />
        )
      }
      data-testid="HeartFavouriteButton"
      data-mark={isFavourite ? 'Favorite' : 'NotFavorite'}
    />
  );
};
